import { Box, Button, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { usePatchCvMutation } from "../../../lib/cvsSlice";
import { useCvStepNavigation } from "../../../contexts/CvStepNavigationContext";

const Summary = ({ summary, cvId }) => {
  const [summaryText, setSummaryText] = useState(summary || "");
  const [isSaving, setIsSaving] = useState(false);
  const isDirty = useRef(false);

  const { goToNextStep } = useCvStepNavigation();
  const [patchCv] = usePatchCvMutation();

  // Sync with backend value only when the user hasn't made unsaved edits
  useEffect(() => {
    if (!isDirty.current) {
      setSummaryText(summary || "");
    }
  }, [summary]);

  const handleChange = (event) => {
    isDirty.current = true;
    setSummaryText(event.target.value);
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await patchCv({ cvId, summary: summaryText }).unwrap();
      isDirty.current = false;
      goToNextStep();
    } catch (err) {
      toast.error(`Failed to save summary: ${err?.data?.message ?? err.message}`);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      {/* Text field */}
      <TextField
        id="profile-summary"
        label="Enter professional summary"
        multiline
        rows={6}
        value={summaryText}
        onChange={handleChange}
        onFocus={() => {
          if (summaryText === "No summary provided.") {
            isDirty.current = true;
            setSummaryText("");
          }
        }}
        variant="outlined"
        fullWidth
      />

      {/* NEXT */}
      <Box>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={isSaving}
          sx={{
            backgroundColor: "#E84610",
            "&:hover": { backgroundColor: "#C73A0D" },
            "&:disabled": { backgroundColor: "#E8A090" },
            borderRadius: "6px",
            px: 3,
            fontWeight: 600,
            letterSpacing: "0.5px",
          }}
        >
          {isSaving ? "Saving..." : "NEXT"}
        </Button>
      </Box>
    </Box>
  );
};

export default Summary;
